import block from './block.json';

export const cardResourceThemeAttributes = {
	backgroundColor: '@tokens.variants.default.cardBackgroundColor',
	minWidth: '200px',
	maxWidth: '280px',
	border: {
		color: '@tokens.variants.default.cardBorderColor',
		width: {
			top: [2, 2],
			right: [2, 2],
			bottom: [2, 2],
			left: [2, 2],
		},
		radius: {
			topLeft: [0, 0],
			topRight: [0, 0],
			bottomRight: [0, 0],
			bottomLeft: [0, 0],
		},
	},
	padding: {
		top: [10, 20],
		right: [10, 20],
		bottom: [10, 20],
		left: [10, 20],
	},
	uptitle: {
		backgroundColor: '@tokens.variants.default.cardBorderColor',
		color: '@tokens.variants.default.cardBackgroundColor',
		typography: '@tokens.typographies.heading-6',
		textAlignment: 'left',
	},
	title: {
		color: '@tokens.variants.default.cardTitleColor',
		typography: '@tokens.typographies.heading-4',
		textAlignment: 'left',
	},
	description: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.paragraph',
		textAlignment: 'left',
	},
	cta: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.links',
		textAlignment: 'left',
	},
	play: {
		width: [32, 48],
		height: [32, 48],
		background: '@tokens.variants.default.cardBackgroundColor',
		foreground: '@tokens.variants.default.cardTitleColor',
	},
	image: {
		height: [80, 100],
	},
	states: {
		hover: {}, // adds hover state
	},
};

export const CardResourceThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: cardResourceThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
